<template>
  <div>
    <h3 class="modal-title"> DYNAMIC WORKFLOW REQUESTOR </h3>
    <b-form-group :class="{'error-input' : $v.data_workflow.title.$error}">
      <label> Dynamic Workflow Title </label>
      <j-input
        v-model="$v.data_workflow.title.$model"
        :max-length="255"
        placeholder="Workflow Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_workflow.workflow.$error}">
      <label> Select Workflow </label>
      <j-single-select
        v-model="$v.data_workflow.workflow.$model"
        :options="workflowList"
        label="name"
        value-format="object"
        placeholder="Choose Workflow"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_workflow.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_workflow.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_workflow.rule.$error}">
      <label> Select Rule </label>
      <j-single-select
        v-model="$v.data_workflow.rule.$model"
        :load-options="loadOptionsRule"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Rule'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeWorkflow">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveWorkflow">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_workflow: {
      title: {
        required,
      },
      workflow: {
        required,
      },
      form: {
        required,
      },
      rule: {
        required,
      },
    },
  },
  data() {
    return {
      data_workflow: {
        title: '',
        workflow: null,
        form: null,
        rule: null,
      },
      workflowList: [],
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['form_detail', 'rule_detail', 'workflow_list', 'workflow_detail']),

    generateDataWorkflow() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_workflow.form.id,
          rule_id: this.data_workflow.rule.id,
        }),
        value_id: `${this.data_workflow.workflow.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_workflow.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataWorkflowUpdate() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_workflow.form.id,
          rule_id: this.data_workflow.rule.id,
        }),
        value_id: `${this.data_workflow.workflow.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_workflow.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  watch: {
    workflow_list(data) {
      this.workflowList = data;
    },
  //   form_detail(data) {
  //     this.data_workflow.workflow = {
  //       id: data.id,
  //       name: data.name,
  //       label: data.name,
  //     };
  //   },

  //   rule_detail(data) {
  //     this.data_workflow.rule = {
  //       id: data.id,
  //       name: data.name,
  //       label: data.name,
  //     };
  //   },
  },
  async mounted() {
    this.actionGetDynamicWorkflow();

    if (this.modeEdit) {
      const formDetail = await this.getDetailForm({
        additional_info_block: {
          id: Number(JSON.parse(this.dataEdit.info).form_id),
        },
      });
      this.data_workflow.form = {
        id: formDetail.id,
        name: formDetail.name,
        label: formDetail.name,
      };

      await this.actionFindDynamicWorkflow(Number(this.dataEdit.value_id));
      this.data_workflow.workflow = {
        id: this.workflow_detail.id,
        name: this.workflow_detail.name,
        label: this.workflow_detail.name,
      };

      const ruleDetail = await this.getDetailRule({
        id: Number(JSON.parse(this.dataEdit.info).rule_id),
      });
      this.data_workflow.rule = {
        id: ruleDetail.id,
        name: ruleDetail.name,
        label: ruleDetail.name,
      };

      this.data_workflow.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm', 'getDetailRule', 'createOrganigramFormRule', 'getOrganigramId', 'actionGetDynamicWorkflow', 'actionFindDynamicWorkflow']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    loadOptionsRule({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListRule', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    async saveWorkflow() {
      this.$v.data_workflow.$touch();
      if (!this.$v.data_workflow.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataWorkflow,
            id: this.dataMaster.id,
          };
          const res = await this.saveComponent(dataParam);
          if (!res.error) {
            const organigramId = await this.getOrganigramId({ id: this.data_workflow.rule.id });
            const param = {
              mode: 'create',
              organigram_id: organigramId.data[0],
              mapping: [{
                id: 0,
                form_id: this.data_workflow.form.id,
                rule_id: this.data_workflow.rule.id,
                is_delete: false,
              }],
            };
            await this.createOrganigramFormRule(param);
          }
        } else {
          const dataParam = {
            data: this.generateDataWorkflowUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeWorkflow();
      }
    },

    closeWorkflow() {
      this.$emit('close-field');
      this.data_workflow.title = '';
      this.data_workflow.workflow = null;
      this.data_workflow.form = null;
      this.data_workflow.rule = null;
      setTimeout(() => {
        this.$v.data_workflow.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jBaktiWorkflowReqSetup.vue